module.exports = __webpack_public_path__ + "img/commerce7-text-from-commerce7.95641c82.png";